const questions = [
    {
        "id": 1,
        "question":
        "350円の買い物をして,1,000円札を出すと,おつりはいくらになりますか。",
        "answer": "650"
      },
    {
        "id": 2,
        "question": 
        "生徒が1列に5人ずつ8列並んでいます。全部で何人いますか。",
        "answer": "40"
      },
    {
        "id": 3,
        "question": 
        "あるクラスで37人が出席し,4人が欠席しました。このクラスの生徒は全員で何人ですか。",
        "answer": "41"
      },
    {
        "id": 4,
        "question": 
        "A, B, Cの3人が持っているお金の合計は6,000円です。Aは3,000円持っています。BとCは同額だとすると,Cの持っているお金はいくらになりますか。",
        "answer": "1500"
      },
    {
        "id": 5,
        "question": 
        "自動車にのって105km離れた町へ時速35kmの速さで行くと,何時間かかりますか。",
        "answer": "3"
      },
    {
        "id": 6,
        "question": 
        "家から駅へ行くのに25分かかります。8時10分に駅に着くためには,家を何時何分に出ればよいでしょうか。",
        "answer": ["7","45"]
      },
    {
        "id": 7,
        "question": 
        "ある本を全体の3分の1まで読んだところ,まだ100ページ残っていました。この本は全部で何ページありますか。",
        "answer": "150"
      },
    {
        "id": 8,
        "question": 
        "12km離れた2つの町を往復するのに,行きは時速6kmの速さで,帰りは時速4kmの速さで歩きました。往復に何時間かかりましたか。",
        "answer": "5"
      },
    // 49page
    {
        "id": 9,
        "question": 
    `次の6個の数字は一定の規則で並んでいます。この規則に従うとXにはどんな数字がはいるでしょうか。
    2 3 5 8 12 17 X`,
        "answer": "23"
        },
    {
        "id": 10,
        "question": 
        "0, 1, 2の数字を書いた3枚のカードがあります。この3枚のカードを横に並べて,3けたの整数をつくると全部で何通りできますか。",
        "answer": "4"
      },
    {
        "id": 11,
        "question": 
        "ある容器に水が入っています。全体の量の5分の4にあたる240リットルを流しました。容器には何リットルの水が残っていますか。",
        "answer": "60"
      },
    {
        "id": 12,
        "question": 
    `A, B, C, Dの4人が1列に並んで走っています。次のことがわかっているとき,先頭にいるのは誰になりますか。
    (1)AはCの前
    (2)Cの1人おいて前はB
    (3)DはCのうしろ`,
        "answer": "B"
      },
    
    {
        "id": 13,
        "question": 
        "2冊の本があります。ページ数を合わせると600ページで,1冊は他の1冊よりも100ページ多くなっています。厚い方の本は何ページですか。",
        "answer": "350"
      },
    {
        "id": 14,
        "question":
        "大小2つの立方体があります。1辺の長さを比べたところ,大きい方が小さい方の3倍あります。大きい方の体積は小さい方の体積の何倍になりますか。",
        "answer": "27"
      },
    {
        "id": 15,
        "question": 
        "ある学級50人のうち6割が男子です。男子の3分の2,女子の2分の1が部活動をやっています。部活動をやっている人は,男女合わせて何人ですか。",
        "answer": "30"
      },
    // 50page
    {
        "id": 16,
        "question":
        "ある品物の今月の値段は,1か月前の値段より1割値上がりして2,200円です。では,この品物の1か月前の値段はいくらでしたか。",
        "answer": "2000"
      },
    {
        "id": 17,
        "question": 
        "小さな正方形のタイル100個をしきつめて,1つの大きな正方形をつくりました。この大きな正方形の4辺にあたるタイルの数は合計何個ですか。",
        "answer": "36"
      },
    {
        "id": 18,
        "question": 
        "長さ3mのひもを4つに切りたいとおもいます。それぞれの長さが10cmずつちがうように切るとすると,一番長いのを何cmに切ればよいでしょうか。",
        "answer": "90"
      },
    {
        "id": 19,
        "question": 
        `A, B, C, D, Eの5人は体重がそれぞれ異なっています。次のようなことがわかっているとき,5人のうち最も体重の重いのは誰ですか。
    (1)Aは重い方から2番目
    (2)EはCより軽く,Dより重い
    (3)BはAより軽い`,
        "answer": "C"
      },
    {
        "id": 20,
        "question": 
        "AとBとCの3人の数学の試験の平均点は65点です。AはBより20点,BはCより5点成績が上でした。では,Aは何点ですか。",
        "answer": "80"
      }
      ];

      export default questions;
    